import productService from "../../services/productService";
import {
  PRODUCT_XML_ADD_FAILURE,
  PRODUCT_XML_ADD_REQUEST,
  PRODUCT_XML_ADD_SUCCESS,
  PRODUCT_EXCEL_GET_FAILURE,
  PRODUCT_EXCEL_GET_SUCCESS,
  PRODUCT_EXCEL_GET_REQUEST,
  PRODUCT_FILTER_UPDATE_REQUEST,
  PRODUCT_FILTER_UPDATE_SUCCESS,
  PRODUCT_FILTER_UPDATE_FAILURE,
  PRODUCTS_FETCH_FAILURE, PRODUCTS_FETCH_REQUEST, PRODUCTS_FETCH_SUCCESS
} from "./actionTypes";


export const addXML = (productData) => {
  return async (dispatch) => {
    dispatch({ type: PRODUCT_XML_ADD_REQUEST });
    try {
      const response = await productService.addXmlProduct(productData);

      const { data } = response;
      dispatch({ type: PRODUCT_XML_ADD_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: PRODUCT_XML_ADD_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
};

export const getExcelAction = (userId, token) => {
  return async (dispatch) => {
    dispatch({ type: PRODUCT_EXCEL_GET_REQUEST });
    try {
      const response = await productService.getExcel(userId, token);

      const { data } = response;
      dispatch({ type: PRODUCT_EXCEL_GET_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: PRODUCT_EXCEL_GET_FAILURE, error: error.message });
      return Promise.reject(error);
    }


  };

};

export const updateProductFilters = (filters) => {
  return async (dispatch) => {
    dispatch({ type: PRODUCT_FILTER_UPDATE_REQUEST });
    try {
      const response = await productService.fetchProducts(filters);
      const { data } = response;
      dispatch({ type: PRODUCT_FILTER_UPDATE_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: PRODUCT_FILTER_UPDATE_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
}


export const fetchProducts = (model, authUserId, page = 1, pageSize = 10,token) => async (dispatch) => {
  dispatch({ type: 'PRODUCTS_FETCH_REQUEST' });
  try {
    const response = await productService.fetchProducts(model, authUserId, page, pageSize,token);
    const { data } = response;
    dispatch({
      type: 'PRODUCTS_FETCH_SUCCESS',
      payload: {
        products: data.data,
        totalProducts: data.recordsTotal,
      },
    });
  } catch (error) {
    dispatch({
      type: 'PRODUCTS_FETCH_FAILURE',
      payload: error.message,
    });
  }
};
